import { ChangeDetectionStrategy, Component, inject, input, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BuildingService } from '@artemis-software/wr-api';
import { Tracked } from '@/utils/signals/tracked';
import { loader } from '@/utils/signals/loader';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-building-popover',
  templateUrl: './building-popover.component.html',
  styleUrls: ['./building-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildingPopoverComponent {
  readonly router = inject(Router);
  readonly buildingService = inject(BuildingService);

  loading = loader();
  readonly buildingId = input.required<string>();

  readonly building = asyncComputed(() => {
    const buildingId = this.buildingId();
    return this.buildingService.findById(buildingId);
  },undefined, this.loading);


  @Input()
  @Tracked()
  disableLink = false;


  navigateToDetail() {
    this.router.navigate(['building', this.buildingId()]);
  }
}
